import agencyApi from 'api/agencyApi';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay danh sach dai ly
export const thunkGetInvestorList = createAsyncThunk(
  'investor/thunkGetInvestorList',
  async ({ params }, thunkAPI) => {
    const res = await agencyApi.getAgencyList(params);
    return res;
  }
);

// ---- params ----
const initialState = {
  isGettingData: false,
  investorList: [],
  total: 0,
};

const investorSlice = createSlice({
  name: 'investor',
  initialState,
  reducers: {},
  extraReducers: {
    [thunkGetInvestorList.pending]: (state, action) => {
      state.isGettingData = true;
    },
    [thunkGetInvestorList.rejected]: (state, action) => {
      state.isGettingData = false;
    },
    [thunkGetInvestorList.fulfilled]: (state, action) => {
      state.isGettingData = false;
      const { result, agencies, total } = action.payload;
      if (result === 'success') {
        state.investorList = agencies ?? [];
        state.total = total ?? 0;
      }
    },
  },
});

const { reducer, actions } = investorSlice;
export const { } = actions;
export default reducer;
